<template>
  <div ref="namo" class="textEditorWrap" id="textEditorWrap">

  </div>
</template>

<script>

function loadNamoWeb() {
	return new Promise( (resolve, reject)=>{
		const exscript = document.createElement('script');
		// exscript.src = 'http://namo.yofill.co.kr/js/namo_scripteditor.js';
		// exscript.src = process.env.NODE_ENV == "development" ? '/editer/js/namo_scripteditor.js' : 'https://analysis.kist.re.kr/namo/js/namo_scripteditor.js';;
		exscript.src = '/editer/js/namo_scripteditor.js';
		document.head.appendChild(exscript);
		// document.domain = 'namo.yofill.co.kr';
		exscript.onload = resolve;
		exscript.onerror = reject;
	} )
}

export default {
  name:'NamoWebEditor',
	props: {
		content: {type:String, default:''}
	},
  data() {
    return {

    }
  },
  async mounted() {
	// console.log( "process.env.NODE_ENV", process.env.NODE_ENV );
    let res = await loadNamoWeb();
		let wrapRect = document.querySelector('.wikiWrap').getClientRects();
		// this.NamoEditor = new NamoSE('namoWeb');
		this.NamoEditor = new NamoSE('namoEditor');
		this.NamoEditor.params.ParentEditor = this.$refs.namo;
		// this.NamoEditor.params.UserDomain = 'namo.yofill.co.kr';
		// this.NamoEditor.params.EditorBaseURL = 'http://namo.yofill.co.kr';
		this.NamoEditor.params.EditorBaseURL = process.env.NODE_ENV == "development" ? 'http://localhost:8080/editer' : '/m3dhub/editer';
		this.NamoEditor.params.UserToolbar = true;
		// this.NamoEditor.params.CreateToolbar = "word_style|spacebar|word_color|cancelattribute|spacebar|word_listset|spacebar|word_indentset|spacebar|word_justify|spacebar|tableinsert|tabledraginsert|spacebar|tablerowinsert|tablerowdelete|tablecolumninsert|tablecolumndelete|spacebar|tablecellmerge|tablecellsplit|spacebar|tablecellattribute|tablecellbgcolor|tableborder_group";
		this.NamoEditor.params.CreateToolbar = "word_style|fontsize|lineheight|spacebar|word_script|spacebar|word_color|cancelattribute|spacebar|word_listset|spacebar|word_indentset|spacebar|word_justify|enter|tabledraginsert|spacebar|tablecellbgcolor|tablecellmerge|spacebar|word";
		this.NamoEditor.params.NewToolbar = true;
		this.NamoEditor.params.Menu = false;
		this.NamoEditor.params.CreateTab = '0';
		this.NamoEditor.params.QuickMenu  = false;
		this.NamoEditor.params.ImageSrcBase64 = true;
		this.NamoEditor.params.PluginModeExecutePath = '/m3dhub/soap/api/v1/file/namo/upload';
		// this.NamoEditor.params.PluginModeUseBase64 = true;
		this.NamoEditor.params.Width = '100%';
		this.NamoEditor.params.Height = wrapRect[0].height - 180;
		this.NamoEditor.params.DefaultFont = 'NanumSquare';
		this.NamoEditor.params.Font = {NanumSquare:'NanumSquare', Pretendard:'Pretendard'};
		this.NamoEditor.NoSpellCheck = true;
		this.NamoEditor.params.AutoInstall = true; //플러그인 자동 설치
    	this.NamoEditor.params.event = {
			OnInitCompleted: (e) => {
				this.$emit('ready', this.NamoEditor);
				this.NamoEditor.InsertValue(0, this.content);
			},
			CE_OnKeyActive: (e) => {
				
			},
		}
    this.NamoEditor.EditorStart();
		this.$emit('init', {editor: this.NamoEditor});
  }
}

</script>

<style>

</style>